import type { SVGProps } from 'react';
const DawnFlagSH = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-SH_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-SH_svg__a)">
      <path fill="url(#dawn-flag-SH_svg__b)" d="M0 0h22v16H0z" />
      <path
        fill="#8FC5FF"
        fillRule="evenodd"
        d="M13.62 8V5.6c0-.737.596-1.333 1.333-1.333h2.57c.737 0 1.334.596 1.334 1.332V8c0 2.668-2.619 3.734-2.619 3.734S13.62 10.667 13.62 8"
        clipRule="evenodd"
      />
      <mask
        id="dawn-flag-SH_svg__c"
        width={6}
        height={8}
        x={13}
        y={4}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M13.62 8V5.6c0-.737.596-1.333 1.333-1.333h2.57c.737 0 1.334.596 1.334 1.332V8c0 2.668-2.619 3.734-2.619 3.734S13.62 10.667 13.62 8"
          clipRule="evenodd"
        />
      </mask>
      <g mask="url(#dawn-flag-SH_svg__c)">
        <path
          fill="#366CC9"
          fillRule="evenodd"
          d="M15.785 9.507s.524-.692.832-.692c.309 0 .365.46.84.46.474 0 .724-.732 1.18-.732.457 0 0 2.4 0 2.4l-.618.65-3.623.426z"
          clipRule="evenodd"
        />
        <path
          fill="#CF6200"
          fillRule="evenodd"
          d="M14.242 8.441 14.704 8l.455 1.133.61-1.133.524 3.228-.872-.18-2.85-1.327z"
          clipRule="evenodd"
        />
        <path fill="#FF0" d="M13.619 4.267h5.238v3.2h-5.238z" />
      </g>
      <path
        stroke="#fff"
        strokeWidth={0.667}
        d="M13.953 8V5.599a1 1 0 0 1 1-1h2.57a1 1 0 0 1 1 1V8c0 1.212-.59 2.062-1.2 2.62a4.8 4.8 0 0 1-1.085.746 4.84 4.84 0 0 1-1.084-.746c-.61-.558-1.201-1.408-1.201-2.62Z"
      />
      <mask
        id="dawn-flag-SH_svg__d"
        width={6}
        height={8}
        x={13}
        y={4}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          stroke="#fff"
          strokeWidth={0.667}
          d="M13.953 8V5.599a1 1 0 0 1 1-1h2.57a1 1 0 0 1 1 1V8c0 1.212-.59 2.062-1.2 2.62a4.8 4.8 0 0 1-1.085.746 4.84 4.84 0 0 1-1.084-.746c-.61-.558-1.201-1.408-1.201-2.62Z"
        />
      </mask>
      <path
        fill="#DB1E36"
        fillRule="evenodd"
        d="M3.667 3.2 0 0h.524L4.19 2.667h1.048L9.428 0v.364a.33.33 0 0 1-.137.27L5.761 3.2v1.067L9.078 7.16a.175.175 0 0 1-.115.307"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M3.667 3.2v1.067L0 6.933v.534L4.19 4.8H5.24l3.62 2.633a.175.175 0 0 0 .218-.273L5.762 4.267V3.2L9.292.633a.33.33 0 0 0 .137-.27V0l-4.19 2.667H4.19L.524 0H0zm.74-1.2L.742-.667h-2.518L3 3.503v.424L-.666 6.594V8.68l5.051-3.214h.637l3.445 2.505a.84.84 0 0 0 .495.161c.778 0 1.14-.964.554-1.476L6.429 3.964V3.54l3.255-2.368a1 1 0 0 0 .412-.808v-1.578L5.044 2z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M0 2.667V4.8h3.667v2.533c0 .369.298.667.666.667h.762a.667.667 0 0 0 .667-.667V4.8h3.524a.667.667 0 0 0 .666-.667v-.8a.667.667 0 0 0-.666-.666H5.762V0H3.667v2.667z"
        clipRule="evenodd"
      />
      <path
        fill="#DB1E36"
        fillRule="evenodd"
        d="M0 3.2h4.19V0h1.048v3.2h4.19v1.067h-4.19v3.2H4.19v-3.2H0z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-SH_svg__b"
        x1={0}
        x2={0}
        y1={0}
        y2={16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#07319C" />
        <stop offset={1} stopColor="#00247E" />
      </linearGradient>
    </defs>
  </svg>
);
export default DawnFlagSH;
